import React, { useEffect, useState } from 'react'
import useMobileDetect from 'helpers/mobile-detect'

import styles from './about-reason.module.scss'

export default function AboutReason (props) {
  const [imageUrl, setImageUrl] = useState('/static/images/about/bg-reason.png')
  const [imageBeforeUrl, setImageBeforeUrl] = useState('/static/images/about/bg-m-before.png')
  const [imageAfterUrl, setImageAfterUrl] = useState('/static/images/about/bg-m-after.png')
  const currentDevice = useMobileDetect()
  const bgBefore =
    'url(' + imageBeforeUrl + ') no-repeat top left /cover'
  const bgAfter =
    'url(' + imageAfterUrl + ') no-repeat top left /cover'
  const bgImage = 'url(' + imageUrl + ') no-repeat center center / cover'

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImageUrl('/static/images/about/bg-m-reason.png')
      setImageBeforeUrl('/static/images/about/bg-m-before.png')
      setImageAfterUrl('/static/images/about/bg-m-after.png')
    } else {
      setImageUrl('/static/images/about/bg-reason.jpg')
      setImageBeforeUrl('/static/images/about/bg-before.svg')
      setImageAfterUrl('/static/images/about/bg-after.svg')
    }
  }, [currentDevice.width])

  return (
    <section className={styles['the-reason']} style={{ background: bgImage }}>
      <div className='container ms-auto me-auto'>
        <h4 className={styles['the-reason__title'] + ' text-center'}>the story behind the dolce diet</h4>
        <div className='row'>
          <div className={styles['the-reason__box-item'] + ' col-12 col-md-6 col-lg-5'}>
            <p className={styles['the-reason__content']}>
              Mike was intially motivated by his own struggle with traditional
              sports nutrition programs and desire to follow a nutritionally
              sound and scientifically proven program that gets real results.
            </p>
          </div>
          <div className={styles['the-reason__box-item'] + ' col-12 col-md-6 col-lg-5 offset-lg-1'}>
            Originating as a humble weight-loss manual entitled ‘3 Weeks to
            Shredded’, The Dolce Diet has expanded to 3 further best-selling
            books and now the most successful personalized diet and exercise
            platform in the world.
          </div>
        </div>
        <div className={styles['the-reason__group-position']}>
          <div className='row'>
            <div className={styles['the-reason__before'] + ' col-12 col-md-5 media'}>
              <img src='/static/images/about/before.png' alt={'Before'} />
              <div className='media-body' style={{ background: bgBefore }}>
                <h4>BEFORE</h4>
                <p>
                  280lbs, 30% body fat <br />
                  on traditional programs
                </p>
              </div>
            </div>
            <div className={styles['the-reason__after'] + ' col-12 col-md-5 media'}>
              <div className='media-body' style={{ background: bgAfter }}>
                <h4>AFTER</h4>
                <p>
                  180lbs, 8% body fat <br /> after The Dolce Diet
                </p>
              </div>
              <img src='/static/images/about/after.png' alt={'After'} />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
